import React, { useMemo } from 'react';
import clsx from 'clsx';
import AccordionContext from './context/context';
import { Element } from '../element';
import Header from './components/header';
import Content from './components/content';
import * as styles from './accordion.styles';

/** @type {typeof import(".").Accordion} */
const Accordion = React.forwardRef(({ className, expanded = false, onChange, icon, children, name, ...props }, ref) => {
  const context = useMemo(() => {
    return {
      expanded,
      onChange,
      icon,
      name,
      ref,
    };
  }, [expanded, onChange, icon, name, ref]);

  return (
    <AccordionContext.Provider value={context}>
      <Element
        as="div"
        className={clsx(styles.accordion, className, {
          [styles.variants.expanded]: expanded,
        })}
        {...props}
      >
        {children}
      </Element>
    </AccordionContext.Provider>
  );
});

if (process.env.NODE_ENV !== 'production') {
  Accordion.displayName = 'Accordion';
}

Accordion.Header = Header;
Accordion.Content = Content;

export default Accordion;
